module.exports = __webpack_public_path__ + "static/media/6-cubes-h.fa59427d.png";